import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Storage } from 'aws-amplify';

import routes from '../../../routes';
import Business from '../Business/Business';
import Hamburger from './Hamburger/Hamburger';

import classes from './Header.module.scss';

const Header = ({ onHamburger, currentPathIsFlow }) => {
  // State
  const [setImageSrc] = useState(null);

  // Global state
  const {
    profile: { s3ProfileImageFileDir }
  } = useSelector(state => state.userData);

  // URL
  const { pathname } = useLocation();

  useEffect(() => {
    const initialize = async () => {
      if (s3ProfileImageFileDir) {
        const s3Response = await Storage.get(s3ProfileImageFileDir);
        setImageSrc(s3Response);
      }
    };
    initialize();
  }, [s3ProfileImageFileDir, setImageSrc]);

  const route = routes.platform.find(({ path }) => path === pathname);
  const pageLabel = route?.title || '';

  const containerClasses = [classes.container];
  currentPathIsFlow && containerClasses.push(classes['color-blue'], classes['hide-sidebar']);
  !currentPathIsFlow && containerClasses.push(classes['color-default']);

  return (
    <header className={containerClasses.join(' ')}>
      {!currentPathIsFlow && <Hamburger className={classes.hamburger} onClick={onHamburger} />}
      <span className={`${currentPathIsFlow ? classes.title : ''} bold-26`}>{pageLabel}</span>
      <Business />
    </header>
  );
};

export default Header;
